export default {
    greyTitle: '#7787a8',
    blackTitle: '#465576',
    greenText: '#42e17d'
};
